import React from "react";
import { config } from "~/config.js";

export const ClubOptionLabel = ({ club }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={club && club.logo && config.media_prefix + club.logo}
        alt={club.name || club.club}
        style={{
          width: "24px",
          height: "24px",
          objectFit: "contain",
          borderRadius: "4px",
        }}
        onError={(e) => {
          e.currentTarget.onerror = null; // Prevent infinite loop if fallback also fails
        }}
      />
      <span>{club.name ? `${club.name}: ${club.full_name}` : club.label}</span>
    </div>
  );
};
